import styled from 'styled-components'
import { PageColumn } from '@components/Page'
import { black, textMuted } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'
import { Pill } from '@components/Pill'

/* The board's toolbar on the page column: the dates read left, the actions sit right; no air above (the board owns its top padding), 24px below. */
export const DateSelectorContainer = styled(PageColumn)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 12px 16px;
	flex-wrap: wrap;
	padding-top: 0;
	padding-bottom: 24px;

	${media.phone} {
		padding-bottom: 16px;
		gap: 8px 12px;
	}
`

/** Import, View Map and Share, right-aligned; drops under the dates when the row is too narrow. */
export const ToolbarActions = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 8px;
	margin-left: auto;
	flex-wrap: wrap;
`

export const DateRangeDisplay = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;

	${media.phone} {
		gap: 8px;
		row-gap: 8px;
	}
`

export const DateDisplayText = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	white-space: nowrap;
`

export const DateDisplayValue = styled.div`
	font-size: ${fontSizes.title};
	color: ${black};
	font-weight: 500;
	white-space: nowrap;

	${media.phone} {
		font-size: ${fontSizes.base};
	}
`

export const DateSeparator = styled.span`
	font-weight: 400;
	color: ${textMuted};
	font-size: ${fontSizes.base};

	${media.phone} {
		font-size: ${fontSizes.small};
	}
`

export const DaysCount = styled(Pill).attrs({ $tone: 'outline' as const, $size: 'lg' as const })`
	${media.phone} {
		padding: 3px 11px;
		font-size: ${fontSizes.small};
	}
`

